import { AxiosInstance } from 'axios';

export const createPWAEvent = (api: AxiosInstance) => {
  return api.post('/events/pwa');
};
